/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHouseReturn} from '@fortawesome/pro-duotone-svg-icons';

const HousesAndTeamsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faHouseReturn} {...props} />
);

export default HousesAndTeamsIcon;
